import { render, staticRenderFns } from "./CompareObs.vue?vue&type=template&id=737db252&scoped=true"
import script from "./CompareObs.vue?vue&type=script&lang=js"
export * from "./CompareObs.vue?vue&type=script&lang=js"
import style0 from "./CompareObs.vue?vue&type=style&index=0&id=737db252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737db252",
  null
  
)

export default component.exports